export default class FilterEvent {
    export() {
        return {
            filter_type: this.filterType,
        };
    }
}
